import { render, staticRenderFns } from "./MainTab.vue?vue&type=template&id=571dc958&scoped=true&"
import script from "./MainTab.vue?vue&type=script&lang=js&"
export * from "./MainTab.vue?vue&type=script&lang=js&"
import style0 from "./MainTab.vue?vue&type=style&index=0&id=571dc958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571dc958",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
